import classNames from 'classnames'
import { Fragment, memo, useEffect, useRef, useState } from 'react'

import Icon from '@/components/Icon/Icon'
import CookieService from '@/services/cookie.service'
import { CardListType } from '@/types/card'

import styles from './Sidebar.module.scss'

export const headerToIcon = (header: string) => {
  header = header.toLowerCase()
  switch (header) {
    case '0 mana':
      return (
        <svg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
          <g fill='none'>
            <circle cx='50' cy='50' fill='#CAC5C0' r='50' />
            <path
              d='M23 52.428c0-9.787 2.061-18.813 6.191-27.072 5.117-10.236 12.123-15.355 21.012-15.355 8.797 0 15.666 4.359 20.605 13.064 4.127 7.186 6.191 15.537 6.191 25.051 0 9.881-2.064 18.814-6.191 26.803-5.031 10.058-12.035 15.081-21.011 15.081-8.531 0-15.305-4.307-20.336-12.926-4.308-7.361-6.461-15.576-6.461-24.646zm11.309-4.444c0 12.926 1.93 22.984 5.795 30.168 2.691 5.025 6.146 7.541 10.367 7.541 10.146 0 15.221-10.506 15.221-31.518 0-9.244-.809-17.059-2.422-23.434-2.785-10.504-7.498-15.76-14.145-15.76-9.879 0-14.816 10.15-14.816 30.443v2.56z'
              fill='#0D0F0F'
            />
          </g>
        </svg>
      )
    case '1 mana':
      return (
        <svg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
          <g fill='none' transform='translate(0 -1)'>
            <circle cx='50' cy='50.998' fill='#CAC5C0' r='50' />
            <path
              d='M55.685 11.001v64.108c0 7.671 3.226 11.504 9.687 11.504h1.684v4.388h-34.111v-4.388h2.141c6.247 0 9.369-3.833 9.369-11.504v-42.054c0-7.758-2.697-11.643-8.081-11.643h-3.429v-4.247h1.237c6.66 0 12.691-2.057 18.08-6.165l3.423.001z'
              fill='#0D0F0F'
            />
          </g>
        </svg>
      )
    case '2 mana':
      return (
        <svg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
          <g fill='none' fillRule='evenodd'>
            <circle cx='50' cy='50' fill='#CAC5C0' r='50' />
            <path
              d='m78.442 69.105-5.681 19.898H25.555v-4.254c2.293-2.652 7.318-8.001 15.076-16.053a331.261 331.261 0 0 0 13.882-15.371c2.291-2.651 4.057-4.942 5.287-6.862 2.733-4.114 4.1-8.32 4.1-12.624 0-4.204-1.254-7.912-3.766-11.112-2.512-3.204-5.752-4.808-9.722-4.808-8.548 0-15.246 5.998-20.094 17.98l-4.235-1.647c5.73-16.829 14.763-25.249 27.106-25.249 6.083 0 11.261 2.149 15.536 6.448 4.278 4.3 6.414 9.604 6.414 15.92 0 8.052-4.449 15.918-13.353 23.601l-9.254 7.956c-5.908 5.127-10.804 9.929-14.676 14.412-.27.273-.796.916-1.587 1.921h24.59c3.79 0 6.656-.776 8.594-2.335 1.672-1.372 3.309-3.98 4.895-7.821h4.094Z'
              fill='#0D0F0F'
            />
          </g>
        </svg>
      )
    case '3 mana':
      return (
        <svg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
          <g fill='none' transform='translate(0 -1)'>
            <circle cx='50' cy='50.998' fill='#CAC5C0' r='50' />
            <path
              d='M39.561 53.562l-2.018-3.771 1.337-.807c5.174-3.145 9.903-6.33 14.189-9.563 4.284-3.232 6.427-6.915 6.427-11.048 0-2.778-1.029-5.112-3.085-6.998-2.061-1.892-4.472-2.834-7.244-2.834-6.439 0-13.234 4.001-20.392 11.991l-3.354-2.559c7.453-11.316 16.566-16.974 27.341-16.974 4.757 0 8.795 1.168 12.122 3.503 3.771 2.607 5.655 6.153 5.655 10.642 0 3.229-1.349 6.374-4.039 9.426-1.528 1.798-4.226 4.132-8.083 7.004l-1.616 1.213c.718-.089 1.572-.134 2.56-.134 4.937 0 8.998 1.887 12.188 5.657 3.188 3.771 4.783 8.17 4.783 13.196 0 8.532-3.595 15.667-10.774 21.416-6.647 5.387-14.325 8.077-23.032 8.077-7.991 0-14.276-1.748-18.858-5.249l2.429-3.371c5.387 2.608 10.279 3.907 14.681 3.907 6.373 0 12.051-2.109 17.032-6.33 4.988-4.22 7.475-9.469 7.475-15.755 0-4.132-1.255-7.655-3.77-10.576-2.516-2.915-5.793-4.374-9.832-4.374-3.684.002-7.723 1.437-12.122 4.311z'
              fill='#0D0F0F'
            />
          </g>
        </svg>
      )
    case '4 mana':
      return (
        <svg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
          <g fill='none' transform='translate(0 -1)'>
            <circle cx='50' cy='50.998' fill='#CAC5C0' r='50' />
            <path
              d='M64.27 68.359v6.723c0 7.684 2.695 11.525 8.094 11.525h2.33v4.394h-32.658v-4.394h2.607c5.303 0 7.961-3.798 7.961-11.392v-6.856h-32.795v-6.861l34.578-50.497h9.883v51.592h.82c3.383 0 5.852-2.608 7.408-7.816h4.115l-1.92 13.583-10.423-.001zm-11.666-5.766v-41.458l-27.893 41.458h27.893z'
              fill='#0D0F0F'
            />
          </g>
        </svg>
      )
    case '5 mana':
      return (
        <svg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
          <g fill='none' transform='translate(0 -1)'>
            <circle cx='50' cy='50.998' fill='#CAC5C0' r='50' />
            <path
              d='M34.957 12.352h28.941c3.754 0 5.988-.45 6.703-1.352h4.156l-2.422 10.925h-35.314l-3.408 15.789c5.127-2.07 9.668-3.104 13.625-3.104 7.729 0 14.25 2.587 19.559 7.758 5.305 5.171 7.961 11.622 7.961 19.357 0 8.996-3.465 16.237-10.394 21.722-6.385 5.039-14.162 7.553-23.338 7.553-5.395 0-10.66-.808-15.785-2.426l1.617-4.046c4.32 1.169 8.141 1.751 11.469 1.751 6.654 0 12.477-2.18 17.473-6.544 4.99-4.358 7.488-9.826 7.488-16.392 0-5.665-1.844-10.32-5.533-13.959-3.689-3.646-8.365-5.468-14.033-5.468-5.213 0-10.07 1.8-14.568 5.396l-2.701-.538 8.504-36.422z'
              fill='#0D0F0F'
            />
          </g>
        </svg>
      )
    case '6 mana':
      return (
        <svg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
          <g fill='none' transform='translate(0 -1)'>
            <circle cx='50' cy='50.998' fill='#CAC5C0' r='50' />
            <path
              d='M36.58 45.675c5.934-5.577 11.91-8.364 17.939-8.364 6.564 0 11.828 2.606 15.787 7.821 3.682 4.77 5.529 10.521 5.529 17.27 0 7.376-2.158 13.849-6.475 19.425-4.768 6.114-10.703 9.174-17.807 9.174-8.547 0-15.381-3.69-20.504-11.063-4.59-6.477-6.883-14.167-6.883-23.071 0-9.44 2.607-18.141 7.824-26.101 5.213-7.958 12.184-13.602 20.906-16.928 4.947-1.888 10.168-2.839 15.65-2.839v4.184c-11.691.631-20.414 5.308-26.174 14.031-2.958 4.501-4.895 9.983-5.792 16.461zm-.812 8.092c-.086 1.618-.133 3.238-.133 4.857 0 6.203 1.078 11.96 3.236 17.269 2.785 6.922 6.883 10.385 12.279 10.385 4.674 0 8.18-2.381 10.52-7.151 1.797-3.684 2.697-8.135 2.697-13.355 0-5.571-.857-10.342-2.563-14.299-2.34-5.396-5.936-8.092-10.793-8.092-5.933-.001-11.017 3.464-15.243 10.386z'
              fill='#0D0F0F'
            />
          </g>
        </svg>
      )
    case '7 mana':
      return (
        <svg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
          <g fill='none' transform='translate(0 -1)'>
            <circle cx='50' cy='50.998' fill='#CAC5C0' r='50' />
            <path
              d='M53.494 91h-11.643v-1.238c0-7.396 2.328-16.659 6.98-27.808 7.035-16.799 13.52-29.673 19.453-38.624l.822-1.232h-27.256c-3.93 0-6.92.819-8.975 2.463-2.059 1.645-3.582 4.387-4.586 8.222h-4.52l4.926-21.782h2.881c1.734.914 4.742 1.371 9.041 1.371h35.609v6.165c-1.275 1.829-2.918 4.75-4.926 8.768-3.838 7.485-7.352 16.208-10.553 26.163-4.743 14.702-7.163 27.209-7.253 37.532z'
              fill='#0D0F0F'
            />
          </g>
        </svg>
      )
    case '8 mana':
      return (
        <svg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
          <g fill='none' transform='translate(0 -1)'>
            <circle cx='50' cy='50.998' fill='#CAC5C0' r='50' />
            <path
              d='M40.965 50.463l-1.746-1.211c-5.119-3.502-8.492-6.33-10.107-8.489-2.066-2.691-3.096-5.83-3.096-9.426 0-6.105 2.557-11.087 7.678-14.949 4.758-3.59 10.281-5.388 16.568-5.388 5.922 0 11.18 1.573 15.756 4.713 5.203 3.503 7.813 8.127 7.813 13.876 0 7.004-4.898 12.66-14.682 16.967 11.131 5.388 16.699 12.884 16.699 22.492 0 6.914-2.646 12.389-7.949 16.434-4.753 3.682-10.729 5.518-17.909 5.518-6.734 0-12.525-1.703-17.377-5.119-5.568-3.856-8.348-8.976-8.348-15.349 0-6.373 2.963-11.63 8.889-15.761 1.616-1.074 4.223-2.51 7.811-4.308zm4.572 1.912c-8.08 3.677-12.111 9.466-12.111 17.361 0 5.113 1.635 9.218 4.916 12.314 3.277 3.097 7.475 4.643 12.594 4.643 4.574 0 8.461-1.232 11.646-3.695 3.186-2.464 4.781-5.891 4.781-10.28 0-6.626-4.367-12.001-13.098-16.122l-8.728-4.221zm9.031-7.973c7.088-3.141 10.641-7.854 10.641-14.139 0-4.313-1.506-7.766-4.51-10.375-3.012-2.603-6.715-3.906-11.113-3.906-3.684 0-6.869.991-9.563 2.964-2.965 2.154-4.443 5.03-4.443 8.62 0 4.4 2.063 7.948 6.195 10.643.805.537 4.396 2.286 10.775 5.25l2.018.943z'
              fill='#0D0F0F'
            />
          </g>
        </svg>
      )
    case '9 mana':
      return (
        <svg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
          <g fill='none' transform='translate(0 -1)'>
            <circle cx='50' cy='50.998' fill='#CAC5C0' r='50' />
            <path
              d='M63.402 56.524c-5.922 5.567-11.898 8.353-17.91 8.353-6.555 0-11.809-2.604-15.758-7.814-3.684-4.758-5.523-10.507-5.523-17.241 0-7.272 2.152-13.777 6.461-19.526 4.672-6.199 10.555-9.296 17.648-9.296 8.622 0 15.489 3.728 20.605 11.181 4.582 6.554 6.867 14.319 6.867 23.302 0 12.746-4.224 23.498-12.655 32.257-8.441 8.752-18.993 13.174-31.653 13.261v-4.175c3.859-.176 6.953-.626 9.297-1.344 12.922-3.951 20.469-13.601 22.621-28.958zm.813-8.082c.086-1.706.129-3.322.129-4.846 0-6.285-1.074-12.034-3.23-17.24-2.875-6.916-7-10.374-12.386-10.374-4.676 0-8.125 2.385-10.375 7.141-1.797 3.683-2.691 8.126-2.691 13.334 0 5.566.852 10.324 2.559 14.275 2.332 5.387 5.926 8.083 10.777 8.083 5.92 0 10.99-3.458 15.217-10.373z'
              fill='#0D0F0F'
            />
          </g>
        </svg>
      )
    case '10 mana':
      return (
        <svg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
          <g fill='none' transform='translate(0 -1)'>
            <circle cx='50' cy='50.998' fill='#CAC5C0' r='50' />
            <path
              d='M35.306 19.633v50.439c0 5.998 2.567 8.998 7.693 8.998h1.305v3.42h-26.866v-3.42h1.727c4.931 0 7.4-3 7.4-8.998v-33.08c0-6.08-2.155-9.123-6.467-9.123h-2.66v-3.424h1.016c5.238 0 9.969-1.604 14.191-4.813l2.661.001zm9.76 33.328c0-7.857 1.646-15.082 4.94-21.668 4.142-8.193 9.805-12.293 16.982-12.293 6.931 0 12.422 3.508 16.476 10.516 3.296 5.748 4.945 12.381 4.945 19.898 0 7.859-1.648 15.039-4.945 21.545-4.141 8.029-9.757 12.041-16.853 12.041-6.842 0-12.293-3.465-16.352-10.395-3.464-5.828-5.193-12.376-5.193-19.644zm9.122-3.676c0 6.68.718 12.676 2.156 17.996 2.197 8.195 5.785 12.295 10.771 12.295 8.111 0 12.165-8.447 12.165-25.346 0-20.869-4.394-31.301-13.182-31.301-7.941 0-11.912 8.105-11.912 24.328l.002 2.028z'
              fill='#0D0F0F'
            />
          </g>
        </svg>
      )
    case '11 mana':
      return (
        <svg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
          <g fill='none' transform='translate(0 -1)'>
            <circle cx='50' cy='50.998' fill='#CAC5C0' r='50' />
            <path
              d='M39.831 19.32v50.84c0 6.049 2.516 9.07 7.536 9.07h1.279v3.449h-27.081v-3.449h1.788c5.109 0 7.667-3.021 7.667-9.07v-33.34c0-6.133-2.173-9.195-6.518-9.195h-2.683v-3.449h1.024c5.28 0 10.047-1.617 14.304-4.855l2.684-.001zm32.449 0v50.84c0 6.049 2.511 9.07 7.537 9.07h1.278v3.449h-27.086v-3.449h1.788c5.115 0 7.667-3.021 7.667-9.07v-33.34c0-6.133-2.173-9.195-6.513-9.195h-2.682v-3.449h1.019c5.28 0 10.047-1.617 14.31-4.855l2.682-.001z'
              fill='#0D0F0F'
            />
          </g>
        </svg>
      )
    case '12 mana':
      return (
        <svg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
          <g fill='none' transform='translate(0 -1)'>
            <circle cx='50' cy='50.998' fill='#CAC5C0' r='50' />
            <path
              d='M35.63 20.215v49.18c0 5.875 2.428 8.816 7.277 8.816h1.278v3.445h-26.185v-3.445h1.533c4.938 0 7.406-2.941 7.406-8.816v-32.32c0-5.955-2.043-8.939-6.128-8.939h-2.682v-3.322h1.019c5.109 0 9.709-1.531 13.795-4.598l2.687-.001zm50.965 46.367l-4.471 15.203h-37.429v-3.32c1.793-2.043 5.749-6.133 11.882-12.266 3.659-3.66 7.324-7.578 10.988-11.748 1.788-2.049 3.191-3.748 4.215-5.115 2.126-3.232 3.191-6.465 3.191-9.703 0-3.238-.981-6.092-2.938-8.561-1.959-2.471-4.559-3.705-7.791-3.705-6.731 0-12.012 4.598-15.843 13.799l-3.321-1.279c4.601-12.775 11.752-19.164 21.461-19.164 4.767 0 8.857 1.621 12.262 4.855 3.404 3.238 5.109 7.281 5.109 12.137 0 6.215-3.534 12.262-10.598 18.141l-7.282 5.873c-4.688 3.92-8.561 7.625-11.628 11.111-.254.262-.681.729-1.273 1.41h19.544c2.979 0 5.192-.557 6.643-1.664 1.445-1.102 2.766-3.107 3.956-6.004h3.323z'
              fill='#0D0F0F'
            />
          </g>
        </svg>
      )
    case '13 mana':
      return (
        <svg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
          <g fill='none' transform='translate(0 -1)'>
            <circle cx='50' cy='50.998' fill='#CAC5C0' r='50' />
            <path
              d='M37.967 20.789v48.543c0 5.707 2.428 8.555 7.282 8.555h1.149v3.322h-25.802v-3.322h1.663c4.938 0 7.406-2.848 7.406-8.555v-31.811c0-5.873-2.089-8.814-6.258-8.814h-2.558v-3.316h1.024c5.021 0 9.538-1.535 13.54-4.602h2.554zm21.717 32.191l-1.533-2.813 1.153-.641c3.831-2.379 7.387-4.785 10.666-7.215 3.274-2.426 4.917-5.17 4.917-8.238 0-2.129-.811-3.898-2.427-5.301-1.617-1.408-3.41-2.109-5.364-2.109-4.943 0-10.136 2.982-15.588 8.945l-2.553-1.918c5.619-8.516 12.517-12.777 20.692-12.777 3.576 0 6.602.895 9.07 2.684 2.896 1.965 4.346 4.645 4.346 8.051 0 2.387-1.024 4.725-3.067 7.021-1.195 1.279-3.238 3.025-6.133 5.24l-1.149 1.023c.51-.082 1.149-.129 1.918-.129 3.748 0 6.81 1.43 9.195 4.277 2.386 2.852 3.576 6.113 3.576 9.771 0 6.475-2.724 11.84-8.177 16.096-4.938 4.086-10.687 6.135-17.24 6.135-6.051 0-10.775-1.279-14.18-3.836l1.788-2.553c4.002 1.871 7.661 2.813 10.982 2.813 4.771 0 9.029-1.574 12.776-4.73 3.748-3.148 5.619-7.068 5.619-11.752 0-3.15-.936-5.83-2.807-8.045-1.877-2.215-4.346-3.322-7.412-3.322-2.722.001-5.747 1.109-9.068 3.323z'
              fill='#0D0F0F'
            />
          </g>
        </svg>
      )
    case '14 mana':
      return (
        <svg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
          <g fill='none' transform='translate(0 -1)'>
            <circle cx='50' cy='50.998' fill='#CAC5C0' r='50' />
            <path
              d='M36.308 20.471v49.053c0 5.789 2.427 8.684 7.276 8.684h1.154v3.322h-26.062v-3.322h1.663c4.938 0 7.407-2.895 7.407-8.684v-32.191c0-5.879-2.09-8.816-6.259-8.816h-2.557v-3.32h1.023c5.021 0 9.579-1.574 13.665-4.725l2.69-.001zm43.047 43.687v5.109c0 5.707 1.996 8.561 6.003 8.561h1.658v3.316h-24.398v-3.316h1.918c4.003 0 6.004-2.813 6.004-8.43v-5.24h-24.528v-5.109l25.932-37.814h7.412v38.578h.639c2.47 0 4.299-1.953 5.489-5.873h3.066l-1.533 10.219-7.662-.001zm-6.773-5.109v-32.189l-21.716 32.189h21.716z'
              fill='#0D0F0F'
            />
          </g>
        </svg>
      )
    case '15 mana':
      return (
        <svg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
          <g fill='none'>
            <path
              d='M100 49.998c0 27.615-22.387 50.002-50.002 50.002-27.613 0-49.998-22.387-49.998-50.002 0-27.613 22.385-49.998 49.998-49.998 27.615 0 50.002 22.385 50.002 49.998z'
              fill='#CAC5C0'
              id='Shape'
            />
            <path
              d='M34.67 18.129v50.84c0 6.045 2.516 9.07 7.537 9.07h1.277v3.445h-27.078v-3.445h1.787c5.109 0 7.666-3.025 7.666-9.07v-33.344c0-6.129-2.172-9.195-6.518-9.195h-2.682v-3.449h1.023c5.281 0 10.047-1.617 14.305-4.852h2.683zm17.885 1.273h23.121c2.984 0 4.771-.336 5.369-1.02h3.322l-1.918 8.688h-28.229l-2.682 12.516c3.998-1.617 7.578-2.428 10.729-2.428 6.133 0 11.305 2.049 15.52 6.135 4.215 4.084 6.32 9.193 6.32 15.328 0 7.152-2.723 12.898-8.17 17.246-5.115 4-11.291 6.004-18.525 6.004-4.258 0-8.43-.641-12.516-1.918l1.273-3.191c3.404.934 6.43 1.402 9.07 1.402 5.281 0 9.902-1.742 13.861-5.234 3.961-3.492 5.936-7.84 5.936-13.031 0-4.512-1.465-8.219-4.402-11.113-2.941-2.895-6.621-4.344-11.051-4.344-4.172 0-8.045 1.449-11.625 4.344l-2.168-.383 6.765-29.001z'
              fill='#0D0F0F'
            />
          </g>
        </svg>
      )
    case 'mythic':
      return <Icon className={styles.icon} icon='m' />
    case 'rare':
      return <Icon className={styles.icon} icon='r' />
    case 'uncommon':
      return <Icon className={styles.icon} icon='u' />
    case 'common':
      return <Icon className={styles.icon} icon='c' />
    case 'special':
      return <Icon className={styles.icon} icon='s' />
    case 'last 3 months':
      return <Icon className={styles.icon} icon='fireFlameSimple' />
    case 'last 6 months':
      return <Icon className={styles.icon} icon='fire' />
    case 'last year':
      return <Icon className={styles.icon} icon='stopwatch' />
    case 'last 2 years':
      return <Icon className={styles.icon} icon='clock' />
    case 'since 2020':
      return <Icon className={styles.icon} icon='hourglassStart' />
    case 'since 2010':
      return <Icon className={styles.icon} icon='hourglassHalf' />
    case 'since 2000':
      return <Icon className={styles.icon} icon='hourglassEnd' />
    case 'new cards':
      return <Icon className={styles.icon} icon='fire' />
    case 'partner with':
      return <Icon className={styles.icon} icon='peopleArrows' />
    case 'doctors':
      return <Icon className={styles.icon} icon='stethoscope' />
    case 'friends forever':
      return <Icon className={styles.icon} icon='heart' />
    case 'partners':
      return <Icon className={styles.icon} icon='hatCowboy' />
    case 'backgrounds':
    case 'new commanders':
      return <Icon className={styles.icon} icon='chessQueen' />
    case '$0.25 - $0.50':
    case '$0.50 - $1':
      return <Icon className={styles.icon} icon='coins' />
    case '$1 - $2.50':
    case '$2.50 - $5':
      return <Icon className={styles.icon} icon='moneyBillWave' />
    case '$5 - $10':
    case '$10 - $20':
      return <Icon className={styles.icon} icon='sackDollar' />
    case '$20 - $50':
    case '$50 - $100':
      return <Icon className={styles.icon} icon='house' />
    case '$100+':
      return <Icon className={styles.icon} icon='landmark' />
  }
  if (header.includes('synergy') || header.includes('lift')) {
    return <Icon className={styles.icon} icon='wandMagicSparkles' />
  } else if (header.includes('creature')) {
    return (
      <svg className={styles.icon} height='16' version='1.1' width='16' xmlns='http://www.w3.org/2000/svg'>
        <g transform='matrix(.026667 0 0 .026667 -13.608 -7.8275)'>
          <path d='m713.86 852.97c-13.242-13.242-14.847-23.546-7.0901-45.531 6.9916-19.816 16.573-30.22 46.999-51.033 15.378-10.52 42.363-30.018 59.965-43.331 30.717-23.23 46.246-32.887 138.58-86.174 67.217-38.792 158-74.98 158-62.982 0 5.7272-21.602 21.173-51.86 37.081-38.85 20.425-148 94.341-180.47 122.21-25.574 21.954-59.523 58.951-95.232 103.78-32.312 40.565-48.283 46.587-68.893 25.977zm-131.41-36.767c-8.453-9.0733-10.259-20.876-6.1929-40.465 5.2375-25.228 4.443-50.054-2.0253-63.294-4.6278-9.4731-9.7564-13.424-30.828-23.747-13.902-6.8108-27.068-14.833-29.257-17.828-8.8835-12.149-1.8544-42.351 16.199-69.602 15.034-22.694 70.089-84.719 103.22-116.28 34.276-32.659 56.126-47.605 82.962-56.747 20.318-6.9218 32.055-12.398 98.218-45.82 78.129-39.467 156.04-62.449 156.04-46.027 0 2.7909-15.37 11.064-42.01 22.613-58.016 25.151-67.516 30.789-109.89 65.205-20.432 16.597-52.724 41.955-71.759 56.352-36.375 27.511-64.188 55.37-93.045 93.197-37.094 48.625-41.041 58.817-29.874 77.133 3.2947 5.4038 5.9411 13.844 5.9904 18.755 0.11904 11.894 5.9224 8.1202 11.542 3.7088 8.326-6.5363 22.885-19.754 46.973-42.43 63.709-59.974 148.65-122.49 207.54-152.73 37.967-19.501 139.97-61.431 168.99-69.468 26.622-7.3723 42.071-8.092 42.071-1.9594 0 5.342-7.4131 9.8459-70.711 42.962-87.207 45.624-123.1 71.603-191.85 138.88-37.247 36.444-103.39 96.203-150.3 135.79-5.4164 4.571-24.868 25.803-43.226 47.182-18.358 21.379-36.856 41.608-41.108 44.952-9.9767 7.8477-20.157 7.7277-27.66-0.32613z' />
        </g>
      </svg>
    )
  } else if (header.includes('instant')) {
    return (
      <svg className={styles.icon} height='16' version='1.1' width='16' xmlns='http://www.w3.org/2000/svg'>
        <g transform='matrix(.020043 0 0 .020043 -.53028 -2.2429)'>
          <path d='m371.58 908.61c-0.98691-0.9867-0.94614-4.0257 0.09-6.7534 1.0367-2.7275 39.211-63.714 84.832-135.53 45.621-71.811 84.606-133.67 86.633-137.46 5.863-10.962 3.0453-25.256-5.9709-30.292-7.1071-3.9695-24.221-1.7812-193.6 24.755-102.19 16.01-189.33 29.071-193.65 29.023-12.63-0.1393-23.667-10.784-23.667-22.829 0-12.775 13.709-39.256 96.334-186.09 76.149-135.32 74.835-130.02 34.293-138.38-13.287-2.7416-18.946-12.094-15.537-25.676 2.9269-11.662 79.523-137.5 91.128-149.71 5.6666-5.9632 15.432-12.379 21.702-14.257 14.405-4.3159 326.25-4.8309 337.49-0.55733 11.073 4.2101 14.825 12.987 10.184 23.823-2.0915 4.8824-78.067 85.998-168.84 180.26-90.768 94.259-166.69 174.54-168.72 178.41-2.9655 5.6598-2.8868 8.1208 0.40223 12.619 3.9334 5.3792 8.1025 4.7774 111.69-16.122 59.181-11.94 112.67-21.699 118.86-21.686 14.927 0.0323 20.998 6.6442 29.312 31.924 15.488 47.095 20.461 50.828 63.564 47.701 32.041-2.3242 40.741 0.87122 37.503 13.774-1.003 3.9957-25.177 30.122-53.72 58.058-28.543 27.936-89.04 87.358-134.44 132.05-162.15 159.62-160.62 158.21-165.88 152.95z' />
        </g>
      </svg>
    )
  } else if (header.includes('sorcer')) {
    return (
      <svg className={styles.icon} height='16' version='1.1' width='16' xmlns='http://www.w3.org/2000/svg'>
        <g transform='matrix(.021096 0 0 .021096 -3.2477 2.1897)'>
          <path d='m549.36 651.16c-7.2611-3.3053-9.7591-6.3834-9.7591-12.025 0-9.6373 8.086-14.821 32.813-21.036 10.615-2.6681 21.087-6.3341 23.272-8.147 6.8108-5.6525 4.4989-16.598-5.2364-24.789-23.098-19.435-67.631-21.565-115.41-5.5191-36.947 12.408-52.507 14.064-79.627 8.4718-34.649-7.1443-67.84-25.037-93.953-50.648-26.212-25.709-39.071-47.213-47.172-78.887-13.779-53.877-1.3118-108.99 31.842-140.75 22.184-21.256 63.33-33.24 73.218-21.325 3.0384 3.6612 1.3796 5.7808-9.8161 12.543-38.979 23.544-42.447 77.096-7.3927 114.16 29.419 31.106 66.365 43.043 133.33 43.077 77.971 0.0397 108.53 6.4694 138.17 29.069 15.917 12.136 33.351 35.333 37.519 49.921 5.0202 17.57 7.8236 20.679 15.123 16.772 9.1305-4.8865 17.306-26.031 17.38-44.953 0.17058-43.532-29.413-86.808-73.864-108.05-17.368-8.2988-26.878-10.321-98.177-20.878-23.048-3.413-33.23-7.907-48.713-21.501-11.789-10.351-19.405-22.99-19.405-32.203 0-8.9134 3.1352-9.4754 23.067-4.1348 14.858 3.9811 19.782 4.2014 27.008 1.2085 13.295-5.5067 20.365-19.683 20.422-40.941 0.11216-42.386-35.185-71.21-114.04-93.123-43.446-12.074-82.243-41.429-98.422-74.47-17.207-35.14-22.25-83.463-12.584-120.57 17.921-68.805 82.063-110.93 161.11-105.81 35.583 2.3054 62.687 13.968 58.744 25.277-0.4129 1.184-14.263 2.3393-30.779 2.5674-19.889 0.2748-34.591 2.1222-43.541 5.4712-43.635 16.328-61.944 50.845-49.677 93.655 7.3361 25.603 28.668 44.991 77.063 70.04 48.433 25.069 50.032 26.214 89.592 64.171 37.995 36.455 51.658 44.901 72.639 44.901 48.476 0 64.725-58.869 28.194-102.15-10.299-12.2-18.442-16.547-60.163-32.112-27.133-10.123-33.202-13.506-33.99-18.949-1.8764-12.965 19.996-15.887 58.89-7.8698 45.314 9.3413 94.901 38.511 137.35 80.8 40.532 40.375 65.356 84.303 80.835 143.04 35.481 134.64-0.2748 268.71-90.852 340.65-22.29 17.704-59.431 35.453-87.677 41.901-31.37 7.1611-94.459 9.0041-107.35 3.1359z' />
        </g>
      </svg>
    )
  } else if (header.includes('artifact')) {
    return (
      <svg className={styles.icon} height='16' version='1.1' width='16' xmlns='http://www.w3.org/2000/svg'>
        <g transform='matrix(.018826 0 0 .018826 -1.9408 1.4622)'>
          <path d='m277.3 767.02c-14.984-4.605-20.642-12.004-17.721-23.175 2.5429-9.7238 25.175-17.243 60.092-19.964 17.637-1.3745 37.915-4.6261 45.062-7.2254 37.254-13.548 73.665-41.337 82.794-63.187 2.4078-5.762 6.9997-43.799 10.861-89.959 6.1682-73.742 6.311-80.394 1.8347-85.341-2.67-2.9505-24.655-15.271-48.856-27.379-38.709-19.367-46.785-24.758-67.157-44.829-21.015-20.705-24.478-25.867-37.453-55.833-15.831-36.562-43.036-116.82-51.307-151.36-4.9614-20.721-6.6558-23.575-24.063-40.523-14.058-13.687-19.246-21.038-20.812-29.488-3.7542-20.263 0.63506-32.423 17.273-47.855l15.187-14.086-2.149-61.024c-2.0875-59.28-1.9671-61.255 4.2097-69.108 3.4972-4.446 11.362-9.4733 17.478-11.172 15.256-4.2372 478.25-4.2372 493.5 0 6.116 1.6987 14.012 6.7563 17.546 11.24 6.2452 7.9212 6.3624 9.7191 4.1508 63.682-1.2518 30.542-2.1258 58.087-1.9421 61.211 0.18274 3.1237 7.0446 11.903 15.246 19.511 16.348 15.164 20.733 27.442 16.998 47.601-1.5676 8.4603-6.7637 15.811-20.918 29.592-17.484 17.023-19.216 19.924-24.182 40.523-8.5681 35.536-35.543 115.43-51.069 151.26-12.981 29.955-16.457 35.135-37.465 55.833-20.372 20.071-28.448 25.462-67.157 44.829-24.201 12.108-46.185 24.429-48.855 27.379-4.4765 4.9463-4.3327 11.631 1.8415 85.745 3.7606 45.141 8.4837 84.691 10.773 90.213 8.7222 21.037 45.997 49.152 82.875 62.511 7.1473 2.589 27.636 5.9337 45.53 7.4323 35.26 2.9534 57.121 10.204 59.624 19.776 3.0121 11.519-2.6713 18.503-19.005 23.354-22.894 6.7991-440.59 6.6369-462.77-0.17897z' />
        </g>
      </svg>
    )
  } else if (header.includes('enchantment')) {
    return (
      <svg className={styles.icon} height='16' version='1.1' width='16' xmlns='http://www.w3.org/2000/svg'>
        <g transform='matrix(.026667 0 0 .026667 -1.9898 -.50576)'>
          <path d='m227.47 561.76c-20.228-3.3536-147.57-32.504-150.85-34.536-4.4587-2.7557 0.63436-6.3738 11.943-8.4841 9.9729-1.8611 82.173-20.269 112.54-28.692 13.228-3.6696 19.032-12.073 14.364-20.796-2.7025-5.0496-66.261-60.979-123.87-109-17.448-14.545-20.996-20.17-12.72-20.17 2.4956 0 41.615 14.965 86.932 33.256 45.317 18.291 84.807 32.799 87.755 32.24 12.293-2.3296 8.1347-17.724-30.484-112.86-36.694-90.393-42.613-108.76-33.376-103.59 2.3728 1.328 33.449 41.239 69.058 88.69 65.019 86.643 70.754 92.552 79.55 81.954 2.1025-2.5335 9.0578-56.115 16.808-129.49 13.496-127.76 14.72-136.32 19.503-136.32 4.3497 0 5.2736 6.6362 19.169 137.69 13.711 129.31 14.976 135.29 27.747 131.24 3.1414-0.99699 35.222-40.979 71.29-88.85 36.068-47.87 66.739-87.037 68.157-87.037 5.885 0 0.85671 15.018-33.705 100.67-19.957 49.456-37.47 93.806-38.919 98.557-3.1527 10.338 1.0368 19.876 8.7299 19.876 2.942 0 40.374-14.356 83.183-31.902 77.073-31.59 94.342-37.447 94.342-31.998 0 1.5467-20.513 20.271-45.585 41.61-99.322 84.533-101.27 86.51-95.609 97.084 3.6353 6.7928 6.0161 7.5739 78.165 25.648 66.485 16.655 64.761 16.108 61.28 19.456-4.078 3.9219-104.24 26.849-163.47 37.417-14.613 2.6073-16.36-1.2618-16.441-36.405-0.0616-26.691-1.2908-35.416-7.0075-49.732-9.6978-24.284-34.126-51.398-59.91-62.872-34.777-15.476-73.571-14.516-103.08-0.0244-47.339 23.251-71.403 66.165-67.373 119.92 1.6775 22.371 1.2042 24.749-3.966 27.763-8.0519 4.6932-17.164 0.84312-24.154-0.3157z' />
        </g>
      </svg>
    )
  } else if (header.includes('battle')) {
    return (
      <svg
        className={styles.icon}
        height='16'
        version='1.1'
        viewBox='-11 0 16 16'
        width='16'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g transform='matrix(.01732 0 0 -.01732 -10.983 15.384)'>
          <path
            d='m50 871q58-17 116.5-37t109.5-55q49-43 93-91t91-93q37 36 73 73.5t72 74.5q51 57 123 81.5t142 46.5q-18-58-36.5-117t-52.5-111q-42-50-89.5-95.5t-92.5-93.5q30-34 63.5-67t34.5-83q27 25 53 51.5t52 52.5q19-21 44-43.5t12-55.5q-15-25-35.5-46.5t-38.5-44.5q32-35 66.5-67t62.5-70q23-37-8-73.5t-71-21.5q-42 27-75 65.5t-70 71.5q-22-19-43-40.5t-48-34.5q-30-6-49.5 18t-40.5 40q25 28 51 54.5t52 53.5q-50 1-84.5 32t-66.5 63q-32-31-66.5-61t-83.5-32q25-28 51-54.5t52-52.5q-20-18-45.5-45.5t-52.5-11.5q-29 17-56.5 44.5l-27.5 27.5-48.5-51t-85.5-80q-38-26-75.5 11.5t-12.5 76.5q26 41 62.5 72.5t66.5 70.5q-22 25-53 55t-30 50q2 22 32.5 51l30.5 29 39.5-39.5t66.5-65.5q1 50 34 83t63 67q-36 37-72.5 74.5t-73.5 74.5q-56 52-79 125t-46 143z'
            fill='currentColor'
          />
        </g>
      </svg>
    )
  } else if (header.includes('planeswalker')) {
    return (
      <svg className={styles.icon} height='16' version='1.1' width='16' xmlns='http://www.w3.org/2000/svg'>
        <defs>
          <clipPath id='clipPath3783-2-9'>
            <path d='m0 300h147v-300h-147z' />
          </clipPath>
        </defs>
        <g transform='matrix(.013287 0 0 .013287 2.2975 5.2996)'>
          <g transform='matrix(4.0816,0,0,-4.0816,128.12,815.48)'>
            <g clipPath='url(#clipPath3783-2-9)'>
              <g transform='translate(145.46,184.26)'>
                <path d='m0 0c-1.245 32.734-4.061 45.164-5.927 45.164-1.894 0-2.49-18.131-4.979-34.153-2.49-15.985-6.874-34.113-6.874-34.113l-11.204 4.268s-3.141 23.131-4.385 50.851c-1.216 27.721-2.164 51.931-5.63 51.931-3.382 0.029-4.031-22.762-5.276-52.296-1.246-29.517-5.601-45.865-5.601-45.865l-10.283 1.433s-4.98 25.602-6.848 103.81c-0.433 18.509-4.951 22.223-4.951 22.223s-4.52-3.714-4.953-22.223c-1.866-78.205-6.874-103.81-6.874-103.81l-10.257-1.433s-4.382 16.348-5.627 45.865c-1.245 29.534-1.869 52.325-5.276 52.296-3.438 0-4.386-24.21-5.659-51.931-1.216-27.72-4.33-50.851-4.33-50.851l-11.204-4.268s-4.382 18.128-6.872 34.113c-2.489 16.022-3.113 34.153-4.979 34.153-1.868 0-4.681-12.43-5.927-45.164-1.245-32.693-1.542-39.084-1.542-39.084s36.777-15.67 51.093-56.223c14.343-40.529 17.969-75.72 18.077-79.627 0.188-6.064 4.33-6.836 4.33-6.836s3.6 0.772 4.33 6.836c0.459 3.879 3.734 39.098 18.075 79.627 14.318 40.553 51.095 56.223 51.095 56.223s-0.299 6.391-1.542 39.084' />
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  } else if (header.includes('land')) {
    return (
      <svg className={styles.icon} height='16' version='1.1' width='16' xmlns='http://www.w3.org/2000/svg'>
        <g transform='matrix(.026667 0 0 .026667 -2.9221 .050774)'>
          <path d='m328.64 541.68c-82.101-7.9017-162.8-28.983-196.57-51.352-35.431-23.469-29.968-47.962 23.264-104.28 47.797-50.572 69.786-92.95 100.82-194.3 20.38-66.56 39.187-108.4 51.901-115.47 19.634-10.914 33.197 4.8825 59.186 68.934 27.624 68.081 51.284 109.37 80.491 140.46 8.817 9.3863 17.39 15.774 21.172 15.774 7.4723 0 18.422-13.086 38.063-45.489 15.901-26.232 28.052-34.478 46.56-31.593 17.139 2.6709 30.08 19.694 45.289 59.576 7.1379 18.717 17.377 42.82 22.754 53.561 10.088 20.151 35.724 57.038 39.718 57.15 4.6042 0.12868 39.132 34.821 43.896 44.105 14.445 28.15-6.8889 53.008-61.484 71.642-65.618 22.396-124.92 31.36-217.51 32.883-38.008 0.62508-81.905-0.0957-97.55-1.6012z' />
        </g>
      </svg>
    )
  } else if (header.includes('commander') || header === 'choose a background') {
    return <Icon className={styles.icon} icon='chessKing' />
  } else if (header.includes('card')) {
    return <Icon className={styles.icon} icon='star' />
  } else if (header.includes('game changer')) {
    return <Icon className={styles.icon} icon='gem' />
  }
  return <Icon className={styles.icon} icon='circle' />
}

type Props = {
  cardLists: CardListType[]
  currentElementIndexInViewport: number
  handleResize: () => void
  setSidebarExpanded: (expanded: boolean) => void
  sidebarExpanded: boolean
  topLeftEdge?: boolean
}

const Sidebar = ({
  cardLists,
  currentElementIndexInViewport,
  handleResize,
  setSidebarExpanded,
  sidebarExpanded,
  topLeftEdge,
}: Props) => {
  const ref = useRef<HTMLDivElement>(null)
  const expandButtonRef = useRef<HTMLDivElement>(null)
  const [hovered, setHovered] = useState(false)

  useEffect(() => {
    setSidebarExpanded(CookieService.get('sidebar-expanded'))
  }, [])

  useEffect(() => {
    CookieService.set('sidebar-expanded', sidebarExpanded)
  }, [sidebarExpanded])

  const nonEmptyCardLists = cardLists.filter((cardList) => cardList.cardviews.length > 0)

  return (
    <div className={classNames(styles.container, { [styles.topLeftEdge]: topLeftEdge })} ref={ref}>
      <div
        className={classNames(styles.sidebar, 'nav nav-pills')}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <div className={styles.headerWrapper}>
          <div className={styles.expandIconRow}>
            <div
              className={styles.expandIcon}
              onClick={() => {
                ref.current?.blur()
                if (setSidebarExpanded) setSidebarExpanded(!sidebarExpanded)
                handleResize()
              }}
              ref={expandButtonRef}
              role='button'
              tabIndex={0}
            >
              <Icon icon={sidebarExpanded ? 'arrowLeft' : 'arrowRight'} />
            </div>
          </div>
          <div
            className={classNames(styles.headers, { [styles.hovered]: hovered, [styles.expanded]: sidebarExpanded })}
          >
            {nonEmptyCardLists.map((cardList, i) => (
              <Fragment key={`${i}-${cardList.tag}`}>
                <div className='nav-item'>
                  <a
                    className={classNames({ active: currentElementIndexInViewport === i }, 'nav-link')}
                    href={`#${i === 0 ? 'cardlists' : cardList.tag}`}
                  >
                    <div className='d-flex'>
                      <div className={styles.iconWrapper}>{headerToIcon(cardList.header)}</div>
                      <div className={styles.iconHeader}>{cardList.header}</div>
                    </div>
                  </a>
                </div>
              </Fragment>
            ))}
            <div className='nav-item'>
              <a className='nav-link' href='#top'>
                <div className='d-flex'>
                  <div className={styles.iconWrapper}>
                    <Icon icon='arrowUp' />
                  </div>
                  <div className={styles.iconHeader}>Back to Top</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default memo(Sidebar)
